import {  map, switchMap } from 'rxjs/operators';
import { Component, ViewChild } from '@angular/core';;
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { GenericmodalComponent, GuidGenerator, mapPlanApiStatusToEnum, mapSubscriptionApiStatusToEnum, QoutationTableComponent, quotation_status, SubscriptionModel } from 'ncache-common-library';
import { finalCostModel, QuotationEnvironmentsModel, subscriptionPeriodModel } from 'ncache-common-library';
import { EnvironmentService } from 'src/app/cloud-subscription/services/environment.service';
import { quotationGlobalState } from 'src/app/global-state/GlobalState';
import { StorageKeys } from 'src/app/Util/storage-keys';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { formatDateUniversal } from 'src/app/Util/dateConverter';
import { FormPersistenceService } from 'src/app/paid-subscription/services/form-persistence.service';
import { faCloud, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HttpErrorResponse } from '@angular/common/http';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { QuotationService } from 'src/app/paid-subscription/services/quotation.service';
import { QuotationType } from 'src/app/enums/quotation.enum';
import { SubscriptionStatus } from 'src/app/enums/subscription.enum';
import Helper from 'src/app/Util/helper';
import { NCacheSubscription } from 'src/app/interfaces/subscription.interface';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { Edition } from 'src/app/enums/plan.enum';
import { CloudProfileService } from 'src/app/services/cloud-profile.service';
import { CompleteUserDetails } from 'src/app/models/user.model';
import { CommonLayoutModule } from "../../../../../../common-layout/common-layout.module";

@Component({
  selector: 'app-newquotation',
  standalone: true,
  imports: [
    QoutationTableComponent,
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    CommonLayoutModule
],
  styleUrls: ['./newquotation.component.sass'],
  templateUrl: './newquotation.component.html',
})
export class NewquotationComponent {
  @ViewChild(QoutationTableComponent) quotationTable!: QoutationTableComponent;
  @ViewChild(GenericmodalComponent) genericModal!: GenericmodalComponent;

  previewData: any[] = [];
  title: string = "Subscription details";
  subscriptionStatus: string = '';
  quotationStatus: string = '';
  isErrorInSupportTable: boolean = false;
  EnvironmentTypes: string[] = [];
  quotationType: string = "";
  maxEnvLength : number = 0
  // finalCost = {};
  faCloud = faCloud
  faCross = faTimesCircle;
  isSubscriptionLoaded: boolean = false;
  userDetails: CompleteUserDetails;



  constructor(
    private route: Router,
    private quotationDetailsService: QuotationService,
    private subService: CloudSubscriptionService,
    private quotationService: QuotationService,
    private activatedRoutes : ActivatedRoute,
    private environmentSvc: EnvironmentService,
    private localStorageService:LocalStorageService,
    private readonly formSrvc:FormPersistenceService,
    private readonly notificationService:CloudNotificationService,
    private cloudService: CloudProfileService,
  ) {}
  quotationPeriod:string
  quotationID: string = '';
  subscriptionId: string = '';
  navigationId: string = '';
  marketplaceId: number = 0;
  cloudProvider: string = '';
  planType: string = '';
  plan: string = '';
  cloudPlan: string = '';
  quotationCategory: string = '';
  isPreviewMode: boolean = false;
  is24x7QuotationEnabled: boolean = false;
  isAddingNewServerQuotationEnabled: boolean = false;
  show247checkBox: boolean = false;
  categoryName: string = '';
  ncacheVersion :string = '';
  operatingSystem: string = 'Linux';
  modalTitle: string = '';
  modalDescription: string = '';
  quotationRequestObj: any;
  isQuotationBeingModifiedBySales = false;
  isEnvironmentNameUnique = true;
  isMidYearQuotation = false;
  isSupportEnabledOnSubscriptionLevel = false;
  quotationEnvironmentsArray: any[] = [];
  serverProfiles: any = [];
  regions: any = [];
  availabilityZones: any = {};
  exisitingEnvironmentNames: any = [];
  finalCost: finalCostModel = new finalCostModel();
  headers: any = [];
  nextHeader : string = ''
  subscriptionInfo: SubscriptionModel[] = [];
  subscriptionData = {};
  isQuotationView: boolean = false;
  isError= false
  redKeys = ['Quote Expires', 'Subscription End Expires'];
  vendor: string = '';
  cloudSubscription:NCacheSubscription

  private getSubscriptionId(){
    this.subscriptionId =  this.localStorageService.getItemSessionStorage(StorageKeys.SubscriptionId).replace(/\\/g, '')
    return this.subscriptionId
  }

  isErrorInQuotationTable(isError:boolean){
    this.isError = isError
  }

  isEnvironmentNameNotUnique(val:boolean){
    this.isError = val
  }

  hideNonHostedEnvironmentMenus()
  {
    return  !Helper.isPlanNonHosted(this.cloudSubscription?.planType)
  }

  showIfNonHosted(){
    return Helper.isPlanNonHosted(this.cloudSubscription?.planType)
  }

  private getExistingEnvNames(){
    this.quotationService.getExistingQuotationEnvironmentNames(this.getSubscriptionId()).subscribe({
      next:(res)=>{
        this.exisitingEnvironmentNames = res
      },
      error:(err)=>{
        this.notificationService.createToastNotification('Existing Env Names',Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
      }
    })
  }

  private getUserData() {
    this.cloudService.getCompleteUserDetails().subscribe({
      next: (res) => {
        this.userDetails = res;
      },
      error: (err) => {
        this.notificationService.createToastNotification("Self Buy",Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
      },
    });
  }


  ngOnInit(): void
  {
    this.getSubscriptionId()
    this.getUserData()
    this.getSubscriptionDetails()
    this.getExistingEnvNames()
    const routeState = history.state;
    this.activatedRoutes.queryParams.subscribe((params) =>
    {
      this.quotationID= params['quotationId'];
      this.quotationType= params['quotationType'];

      if (this.quotationID != '' && this.quotationID != undefined)
      {
        quotationGlobalState.populateQuotationId(this.quotationID)
      }

      if (this.quotationType === "_24x7")
      {
        this.is24x7QuotationEnabled = true;
      }
      else if (this.quotationType == 'MidYear')
      {
        this.isMidYearQuotation = true
        this.getAllExisitngEnviroments(this.subscriptionId)
      }

      else if (this.quotationType == 'MidYear')
        {
          this.isMidYearQuotation = true
          this.getAllExisitngEnviroments(this.subscriptionId)
        }

    });

    quotationGlobalState.resetEnvironmentsNames()

    //state managemnet calls
    quotationGlobalState.getSubscriptionId().subscribe(env=>{
      this.subscriptionId =  env
    })

    quotationGlobalState.getQuotationId().subscribe(env=>{
      this.quotationID =  env
    })


    quotationGlobalState.getCloudProvider().subscribe(env=>{
      this.cloudProvider =  env}
    )

    quotationGlobalState.getPlanEdition().subscribe(env=>{
      this.cloudPlan =  env}
    )


    quotationGlobalState.cloudProvider$.subscribe(env=>{
      this.cloudProvider = env}
    )

    quotationGlobalState.quotationId$.subscribe(env=>{
      this.quotationID = env}
    )

    if (this.quotationID == '')
    {
      this.quotationID = routeState.quotationId
      quotationGlobalState.populateQuotationId(routeState.quotationId)
    }

    quotationGlobalState.quotationEnvironmentsGlobalArray$.subscribe((allEnvironments: any) => {
        this.quotationEnvironmentsArray = allEnvironments;}
    );

    quotationGlobalState.availableServerPlans$.subscribe((serverPlans: any) => {
      this.serverProfiles = serverPlans;}
    );

    quotationGlobalState.regionsBasedOnServerPlan$.subscribe((regions: any) => {
      this.regions = regions;}
    );

    quotationGlobalState.availabilityZonesBasedOnRegionsAndServerPlan$.subscribe((avlZones: any) => {
      if (avlZones && Object.keys(avlZones)?.length > 0)
        {
          Object.keys(avlZones).forEach(e => {
            this.availabilityZones[e] = avlZones[e];
          });
        }      
      }
    );


    quotationGlobalState.existingEnvironments$.subscribe((env:any)=>{
      this.exisitingEnvironmentNames = env}
    );

    quotationGlobalState.finalQuotationCost$.subscribe((env:any) =>
    {
      this.finalCost =  env
      if (this.finalCost == null || this.finalCost == undefined)
      {
        this.finalCost = new finalCostModel()
      }
    })

    quotationGlobalState.getQuotationCategory().subscribe((quotCatName: any) =>
    {
      this.categoryName = quotCatName;
    });


    //all api calls
    if (routeState)
    {
      this.quotationStatus = routeState.quotationStatus
      this.subscriptionStatus = routeState.subscriptionStatus

      this.isQuotationView =  routeState.isQuotationView
      this.subscriptionId = routeState.subscriptionId
      quotationGlobalState.populateSubscriptionId(routeState.subscriptionId)

      if (!this.isQuotationView && routeState.QuotationObject)
      {
        this.quotationRequestObj = routeState.QuotationObject;

        if (this.quotationRequestObj.is24x7Quotation ) //TODO hanlde already exisit 24x7 support for API as no approve or subit button is shwon
        {
          this.is24x7QuotationEnabled = true
          quotationGlobalState.populateQuotationCategory("24x7")
        }
        else if (this.quotationRequestObj.isAddServerQuotation || this.quotationRequestObj.isNewQuotation)
        {
          if (this.quotationRequestObj.isAddServerQuotation)
          {
            this.getQuotationDetails(this.subscriptionId);
            this.isAddingNewServerQuotationEnabled =  true
          }
          else
          {
            this.getAllExisitngEnviroments(this.subscriptionId);
          }
        }

      }
    }

    if (this.quotationID != '' && this.quotationID != undefined && this.quotationEnvironmentsArray.length == 0)
    {
      this.getQuotationByQuotationID(this.quotationID)
    }
      this.getSingleSubscriptionDetails(this.getSubscriptionId());
      if (!this.is24x7QuotationEnabled)
      {
        this.getQuotationPeriod(this.subscriptionId);
      }
      else
      {
        quotationGlobalState.populateQuotationCategory("24x7")
      }


    if (this.cloudPlan == undefined || this.cloudPlan == '')
    {
      this.cloudPlan = routeState.cloudPlan
      quotationGlobalState.populatPlanEdition(this.cloudPlan)
    }

    this.getEnvironmentNameMaxLength()

  }


  getQuotationPeriod(subscriptionID : string)
  {
    let quoteCategory = ""
    quotationGlobalState.getQuotationCategory().subscribe((quoteCat:any)=>
    {
      quoteCategory = quoteCat
    });

    if (quoteCategory !== "24x7")
    {
      this.quotationService.getQuotationPeriod(subscriptionID).subscribe(
      {
        next: (Response) => {

          if (Response == "MidYear")
          {
            this.isMidYearQuotation = true
          }
          quotationGlobalState.populateQuotationCategory(Response)
        },
        error: (error) =>
        {
          this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger)
        },
      })
    }
  }

  checkIfQuotationMidYear(){
    return this.quotationPeriod == QuotationType.MidYear
  }


  getSingleSubscriptionDetails(subscriptionId: string)
  {
    this.subService
      .getSubscriptionDetail(subscriptionId)
      .subscribe((response) =>
      {
        if (response !== undefined)
        {
          if(response.status == SubscriptionStatus.Active){
            this.getAllExisitngEnviroments(this.getSubscriptionId())
          }

          this.planType = response.planType;
          this.cloudProvider = response.vendor;
          this.vendor = response.vendor;
          this.cloudPlan = response.planEdition;
          this.subscriptionData =  this.mapSubscriptionData(response)
          // this.handlePlaneSelected(this.vendor);
          // this.handleRegionSelected(this.vendor);
          this.handleEnvironmentTypes();
        }
      })
  }

  getQuotationByQuotationID(quotationId: string)
  {

    this.environmentSvc
      .getQuotationDetailsById(quotationId)
      .subscribe({
        next: (response) =>
        {
          this.quotationCategory = response.type
          this.categoryName = this.quotationCategory
          quotationGlobalState.populateQuotationEnvironments(
            response.quotationEnvironmentsInfo
          );

          let tempPrice : finalCostModel = new finalCostModel()
          tempPrice.totalCost = response.totalCost
          tempPrice.absoluteCost = response.totalCost
          tempPrice.totalSoftwareCost = response.totalSoftwareCost
          tempPrice.totalInfratStructureCost = response.totalInfraCost
          if (response.discount > 0 )
            {
            tempPrice.totalDiscount = response.discount
            tempPrice.totalCost -=response.discount
            tempPrice.absoluteCost = response.totalCost
          }
          if (response.total24X7Price > 0 )
          {
            tempPrice._24X7Cost = response.total24X7Price
          }

          this.updateFinaCost( new QuotationEnvironmentsModel(), tempPrice)
        },
        error: (error) =>
        {
          this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger)
        },
      });
  }

  getQuotationDetails(subscriptionID: string) {
    let TempArray : QuotationEnvironmentsModel[] =[]

    this.environmentSvc.getQuotationExistingEnvironment(subscriptionID).subscribe({
      next:(res)=>{
        res = this.generateEnvironmentsGuid(res)
        quotationGlobalState.populateQuotationEnvironments(res)
      },
      error:(err)=>{
        this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger)
      }
    });
  }


  getEnvironmentNameMaxLength()
  {
    this.quotationDetailsService.getEnvNameMaxLength().subscribe(
      {
        next:(response) =>
        {
          this.maxEnvLength = response
        },
        error: (error) =>
        {
          this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger)
        },
      }
    )
  }




  handleGet24x7QuotationPrice(event : any)
  {
    this.get24x7quotationPrice(event)
  }


  get24x7quotationPrice(requetObj : any): void
  {
    if (Object.keys(requetObj).length > 0){
    this.quotationDetailsService
    .getQuotationCostWithTwentyFour(requetObj)
    .subscribe({
      next: (response) => {
        this.finalCost._24X7Cost = response
        if (requetObj.TotalSoftwareCost == 0)
          {
            this.finalCost = new finalCostModel()
          }
          else
          {
            this.finalCost._24X7Cost = response.support24X7Cost  || 0
            this.finalCost.totalSoftwareCost = response.totalSoftwareCost || 0
            this.finalCost.totalInfratStructureCost = response.totalInfraCost || 0
            this.finalCost.totalCost = response.totalCost || 0
           }
          this.finalCost.absoluteCost = this.finalCost.totalCost || 0
          quotationGlobalState.updateFinalCost(this.finalCost)
        },
        error: (error) => {
          this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger)
        },
      });
    }
  }


  enable24X7(){
    return this.subscriptionStatus == SubscriptionStatus.AwaitingQuotation
  }


  private getSubscriptionDetails(): void {
    this.formSrvc.getSubscriptionDetails(this.getSubscriptionId())
    .pipe(switchMap((subscription) => {
        return this.quotationService.getQuotationPeriod(this.getSubscriptionId()).pipe(
          map((quotationPeriod) => ({
            subscription,
            quotationPeriod
          }))
        );
      })
    )
    .subscribe({
      next: ({ subscription, quotationPeriod }) => {
        this.isSubscriptionLoaded = true
        this.quotationPeriod = quotationPeriod;
        this.cloudSubscription = subscription
        this.subscriptionStatus = mapSubscriptionApiStatusToEnum( subscription.status)
        this.title = `Request Quotation (${subscription.vendor})`;
        this.nextHeader = `${subscription.planTitle}`
        this.getNCacheVersions(subscription)
      },
      error: (err: HttpErrorResponse) => {
        this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger)
      }
    });

  }

  private getReadableQuotationPeriod(quotationPeriod:QuotationType){
    switch(quotationPeriod){
      case QuotationType.MidYear:
        return "Mid Year"
      case QuotationType._24x7:
        return "24x7"
      case QuotationType.Annual:
        return "Annual"
      default:
        "Awaiting Quotation"
    }
  }

  private getNCacheVersions(subscription){

    this.environmentSvc.getAllNCacheVersions(this.subscriptionId, subscription.planEdition, subscription.planType, '').subscribe({
      next:(res)=>{
        this.getNCacheVersionName(res)
      },
      error:(err)=>{
        this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger)
      }
    })
  }

  getNCacheVersionName(res:any[]){
    if(res.length > 0) this.ncacheVersion =  res[0].displayName
  }





  getAllExisitngEnviroments(subscriptionId : string): void
  {
    let tempEnvNames :string[] =[]
    let localEnvs :QuotationEnvironmentsModel[] =[]

    this.environmentSvc.getQuotationExistingEnvironment(subscriptionId).subscribe({
    next: (response) =>
    {
      response?.map((item: any) =>
        {
        localEnvs.push(this.mapEnvResponse(item))

        if (!tempEnvNames.includes(item.name))
        {
          tempEnvNames.push(item.name)
        }
      });

      quotationGlobalState.populateExistingEnvironments(tempEnvNames)
      localEnvs = this.generateEnvironmentsGuid(localEnvs)
      quotationGlobalState.populateQuotationEnvironments(localEnvs)
    },
    error: (error) =>
    {
      this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger)
    },
    });
  }




  handlePlaneSelected(event: string) {

    if (this.cloudPlan != undefined || this.cloudPlan != '')
    {
      let localServerPlans: any = [];
      this.environmentSvc
      .getAllServerProfiles(this.cloudProvider, this.cloudPlan)
        .subscribe({
          next: (response) => {
            quotationGlobalState.populateServerPlans(this.sortServerProfiles(response));
          },
          error:(error)=>{
            this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger)
          }
        });
    }
  }

  private sortServerProfiles(serverProfiles:any){
    return serverProfiles.sort((a,b)=>{
      var num1 = a.name.match(/\d+/g).map(Number)
      var num2 = b.name.match(/\d+/g).map(Number)
      if( num1[0] + num1[1] > num2[0] + num2[1] ) return 1
      else if(num2[0] + num2[1] > num1[0] + num1[1]) return -1
      else return 0
    })
    .map((profile)=>profile.name)
  }

  checkIfPlanProfessional(){
    return this.cloudPlan == Edition.Professional
  }

  handleDiscounts(event : any)
  {
    // this.quotationService.applyDiscounts(event).subscribe(
    // {
    //   next: (response) =>
    //   {
    //     this.finalCost.totalSoftwareCost = response.softwareCost
    //     this.finalCost.totalInfratStructureCost = response.infraCost
    //     this.finalCost.totalCost = response.totalCost
    //     this.finalCost.absoluteCost = this.finalCost.totalCost
    //     this.finalCost.totalDiscount = response.discount
    //     quotationGlobalState.updateFinalCost(this.finalCost)
    //   },
    //   error:(error)=>{
    //     this.notificationService.showToast(error.error.message, "danger")
    //   }
    // })
  }

  handleEnvironmentTypes()
  {
    this.environmentSvc.getEnvironmentTypes()
      .subscribe({
        next: (response) => {
          this.EnvironmentTypes = response
        },
        error:(error)=>{
          this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger)
        }
      });

  }



 private handleRegionSelected(region: string) {
    let localRegion: any = [];
    this.environmentSvc.getAllRegions(this.cloudProvider)
      .subscribe({
        next: (response) => {
          response.map((item: any) => {
            localRegion.push(item.name);
          });
          quotationGlobalState.populateRegionsForServerPlan(this.sortRegions(localRegion));
        },
        error:(error)=>{
          this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger)
        }
      });

  }
  sortRegions(localRegion: any) 
  {
    // Enhanced custom sort
    localRegion.sort((a: string, b: string) => 
    {
      const aLower = a.toLowerCase();
      const bLower = b.toLowerCase();

      const includesUS = (val: string) => val.includes('us');
      const isUsWithNumber = (val: string) => val.startsWith('us') && /\d/.test(val);

      if (includesUS(aLower) && !includesUS(bLower)) return -1;
      if (!includesUS(aLower) && includesUS(bLower)) return 1;

      if (isUsWithNumber(aLower) && !isUsWithNumber(bLower)) return -1;
      if (!isUsWithNumber(aLower) && isUsWithNumber(bLower)) return 1;

      // Sort by length
      if (a.length !== b.length) return a.length - b.length;

      // Alphabetical fallback
      return a.localeCompare(b);
    });

    return localRegion
  }

  handleAvalibilityZoneSelected(region: string)
  {
    quotationGlobalState.resetavailabilityZonesState()
    let localAvailabilityZones: any = [];
    this.availabilityZones[region] = [];
    this.environmentSvc.getAvailabilityZones(region).subscribe({
      next: (response) => {
        response.map((item: any) => {

          if (item.name != '' || item.name != ' ') {
            localAvailabilityZones.push(item.name);
          }
        });
        quotationGlobalState.populateAvailabilityZones(region, localAvailabilityZones);
      },
      error:(error)=>{
        this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger)
      }
    });
  }

  handleEnvironmentPrices(event: any) {
    this.getEnviromentPrices(event);
  }

  getEnviromentPrices(request: any)
  {
    this.environmentSvc.getEnvironmentPricing(request).subscribe({
      next: (response) =>
      {
        let mappedResponse = this.mapEnvResponse(response)
        quotationGlobalState.editQuotationEnvironment(mappedResponse);
        this.RecalculatePrices(mappedResponse)
      },
      error:(error)=>{
        this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger)
      }
    });
  }


  RecalculatePrices(exisitngEnvironment ? :QuotationEnvironmentsModel)
  {
    if (exisitngEnvironment != null || exisitngEnvironment != undefined)
      {
        let existsIndex= this.quotationEnvironmentsArray.findIndex(env => env.id== exisitngEnvironment.id);
        if (existsIndex != -1 )
        {
          this.quotationEnvironmentsArray[existsIndex]  = exisitngEnvironment
          this.doCalculation(this.quotationEnvironmentsArray[existsIndex].isSupport24X7)
        }
      }
  }

  doCalculation(isSupport24X7:boolean )
  {
      let discount = this.finalCost?.totalDiscount
      this.finalCost =  new finalCostModel()

      this.quotationEnvironmentsArray.map((item:any)=>
      {
        this.finalCost.totalCost += item.subTotal  || 0
        this.finalCost.totalSoftwareCost += item.softwareCost || 0
        this.finalCost.totalInfratStructureCost += item.infraCost || 0
        this.finalCost._24X7Cost += item.support24X7Price || 0
      })

      if (discount > 0)
      {
        this.finalCost.totalDiscount = discount  || 0
        this.finalCost.totalCost -= discount || 0
        this.finalCost.absoluteCost = this.finalCost.totalCost || 0
      }

      if (isSupport24X7)
      {
        let requestObject = {
          "totalSoftwareCost" : this.finalCost.totalSoftwareCost,
          "totalInfraCost" : this.finalCost.totalInfratStructureCost,
        }
        this.handleGet24x7QuotationPrice(requestObject)
      }
      else
      {
        this.updateFinaCost( new QuotationEnvironmentsModel(),this.finalCost)
      }
  }

  checkIfsubscriptionNonHosted(){
    let isHosted = false
    if(this.subscriptionData['Plan Type'] != undefined)
    {
      isHosted = Helper.isPlanNonHosted(this.subscriptionData['Plan Type'])
    }
    return isHosted
  }


  back() {
    this.route.navigate(['/newquotation']);
    quotationGlobalState.resetQuotationGlobalState()
  }


  handleNavigateBack() {
    this.route.navigate(['/subscription/details']);
    quotationGlobalState.resetQuotationGlobalState()
  }


  handleLocalPreview(event: boolean)
  {

    this.isPreviewMode =  event
    if (this.quotationStatus === undefined || this.quotationStatus == "")
    {
      this.quotationStatus = quotation_status.InProgress
    }

    if (this.is24x7QuotationEnabled && this.quotationStatus !== quotation_status.Requested)
    {
      quotationGlobalState.populateIsQuotationModified(this.is24x7QuotationEnabled)
    }



    if(this.finalCost.totalCost == 0){
      return
    }
    this.route.navigate(['/previewquotation'], {
      state: {
        is24x7Quotation: this.is24x7QuotationEnabled,
        quotationModified:this.isQuotationBeingModifiedBySales,
        userDetails : this.userDetails
      },
    });
  }

  handleFinalCost(event: any)
  {
    if (event._24X7Cost > 0 && !this.isPreviewMode)
      {
        this.handleGet24x7QuotationPrice(event.totalSoftwareCost)
      }
    quotationGlobalState.updateFinalCost(event);
  }

  handleUpdatedData(event: any)
  {
    quotationGlobalState.resetQuotationEnvironments()
    quotationGlobalState.populateQuotationEnvironments(event);
  }

  handleUpdatedHeaders(event: any) {
    this.headers = [...event];
  }

  createPreview() {
    if (this.quotationTable) {
      this.quotationTable.displayPreviewContent();
    }
  }

  handlesQuotationDataBeingModified(event:any)
  {
    this.isQuotationBeingModifiedBySales =  event
    quotationGlobalState.populateIsQuotationModified(event)
  }

  handleEnvironmentNameNotUnique(event : any)
  {
    this.isEnvironmentNameUnique = !event
  }

  handleErrorInQuotationTable(event : any)
  {
    this.isErrorInSupportTable = event
  }

  private mapEnvResponse(item:any)
  {
    let environment = new QuotationEnvironmentsModel();
    environment.name = item.name;
    environment.id = item.id
    environment.edition = this.cloudPlan;
    environment.planType = this.planType
    environment.environmentType = item.environmentType;
    environment.existingReservedServerCount = item.existingReservedServerCount;
    environment.serverPlan = item.serverPlan;
    environment.region = item.region;
    environment.availabilityZone = item.availabilityZone;
    environment.totalReservedServerCount = item.totalReservedServerCount ;

    environment.annualInfraListedPrice = item.annualInfraListedPrice;
    environment.nCacheVersion = item.nCacheVersion;

    environment.hourlyInfraListedPrice = item.hourlyInfraListedPrice;
    environment.hourlyInfraPrice = item.hourlyInfraPrice;
    environment.annualInfraListedPrice =item.annualInfraListedPrice;
    environment.annualInfraPrice = item.annualInfraPrice
    environment.infraCost = item.infraCost;

    environment.hourlySoftwarePrice =item.hourlySoftwarePrice;
    environment.hourlySoftwareListedPrice = item.hourlyySoftwareListedPrice;
    environment.annualSoftwarePrice = item.annualSoftwarePrice
    environment.annualSoftwareListedPrice =item.annualSoftwareListedPrice;
    environment.softwareCost = item.softwareCost;


    environment.subTotal = item.subTotal;
    environment.isSupport24X7 = item.isSupport24X7
    environment.support24X7Price = item.support24X7Price
    environment.vendor = this.cloudProvider

    return environment
  }


  private updateFinaCost(environment:QuotationEnvironmentsModel , recievedCost : any)
  {
    if (recievedCost != null && recievedCost != undefined)
    {
      quotationGlobalState.updateFinalCost(recievedCost)
    }
    else
    {

    if (this.finalCost == null )
      {
        this.finalCost =  new finalCostModel()
      }
      this.finalCost.totalCost += environment.subTotal  || 0
      this.finalCost.totalSoftwareCost += environment.softwareCost || 0
      this.finalCost.totalInfratStructureCost += environment.infraCost || 0
      this.finalCost.absoluteCost = this.finalCost.totalCost

      if (this.finalCost._24X7Cost > 0)
      {
        this.finalCost._24X7Cost += environment.support24X7Price || 0
      }
      quotationGlobalState.updateFinalCost(this.finalCost)
    }
  }


  private mapSubscriptionData(data: any): Record<string, string> {

    let subscriptionPeriod : subscriptionPeriodModel =  new subscriptionPeriodModel()
    subscriptionPeriod.subscriptionStartData =formatDateUniversal(data.startTime)
    subscriptionPeriod.subscriptionEndData = formatDateUniversal(data.endTime)
    quotationGlobalState.populateSubscriptionPeriod(subscriptionPeriod)
    this.isSupportEnabledOnSubscriptionLevel  = data?.support247Enabled
    this.subscriptionStatus = mapSubscriptionApiStatusToEnum( data?.status)

    return {

      'Quotation ID': this.quotationID !== undefined ? this.quotationID : '---',
      'Subscription ID': data?.id || '',
      'Customer Name': data?.userName || '',
      'Customer Company': data?.userCompany || '',
      'Customer Email': data?.userEmail || '',
      'Subscription Status':mapSubscriptionApiStatusToEnum( data?.status )|| '',
      '---split---': '',
      'Cloud Provider': data?.vendor || '',
      'Cloud Plan': mapPlanApiStatusToEnum(data?.planEdition) + ' ( ' +this.planType +' ) '  || '',
      'Start Date': data?.startTime ? formatDateUniversal(data.startTime) : '---',
      'End Date': data?.endTime ? formatDateUniversal(data.endTime) : '---',
      '24x7 Support ': data?.support247Enabled? 'Enabled' : 'Disabled',
      'Plan Type':data.planType
    };



  }

  isPlanNonHosted(){
    return Helper.isPlanNonHosted(this.cloudSubscription?.planType)
  }

  private generateEnvironmentsGuid(environments :any[]) : any
  {
    environments.forEach((env:any) =>
    {

      //When moving back from previwe page , this api is called again
      //First check for dupilcate and null id and assign neew GUID
      //Else reassing the old GUID to this Env
      if (env.id == null  && !this.hasDuplicateEnvironmentName(env.name))
      {
        env.id = GuidGenerator.standard()
      }
      else
      {
        let existsIndex = this.quotationEnvironmentsArray?.findIndex(qtEnv => qtEnv.name == env.name);
        if (existsIndex !== -1)
        {
          env.id = this.quotationEnvironmentsArray[existsIndex].id
        }
      }

    })

    return environments
  }

  private hasDuplicateEnvironmentName(name: string): boolean
  {
    const duplicateIndices = this.quotationEnvironmentsArray
      ?.map((env, index) => (env.name === name ? index : -1))
      .filter((index) => index !== -1);

    if (duplicateIndices.length > 0) {
      return true;
    }

    return false;
  }
}
